module.exports = __webpack_public_path__ + "img/icon-implantation-07.22f6712b.svg";